import { useState } from 'react'
import type { MoveResponseDto } from '@/api/generated/api'
import movePlaceholder from '@/images/move-placeholder.png'

interface MoveCardProps {
  move: MoveResponseDto
}

export function MoveCard({ move }: MoveCardProps) {
  const [imageError, setImageError] = useState(false)

  const handleImageError = () => {
    setImageError(true)
  }

  return (
    <div className="flex flex-col">
      {/* Full-width thumbnail */}
      <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-muted">
        <img
          src={
            imageError ? movePlaceholder : move.thumbnailUrl || movePlaceholder
          }
          alt={move.name}
          className="h-full w-full object-cover"
          onError={handleImageError}
          loading="lazy"
          decoding="async"
        />
      </div>
      {/* Text content below thumbnail */}
      <div className="mt-2 flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <h4 className="truncate text-sm font-medium text-black">
            {move.name}
          </h4>
          {move.description && (
            <p className="mt-0.5 line-clamp-2 text-xs text-[#666666]">
              {move.description}
            </p>
          )}
        </div>
        {/* Chevron */}
        <svg
          className="h-4 w-4 flex-shrink-0 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>
    </div>
  )
}
